module.exports = __webpack_public_path__ + "static/media/objects2_05.bd0632db.svg";